import { Link } from '@tanstack/react-router';
import { FileQuestion } from 'lucide-react';
import { Helmet } from 'react-helmet';

import { PageEmptyState } from '@/components/glitch-ui/empty-state';
import { Button } from '@/components/ui/button';

/**
 * The one 404. It says the same thing for a page that does not exist and one the person may not open, so a link
 * into an organization they do not belong to (lib/org-handoff.ts) never confirms that organization exists.
 *
 * `standalone` is the root boundary, drawn with no app shell around it; inside the layout the page sits in the
 * content area beside the sidebar.
 */
export function NotFoundPage({ standalone = false }: { standalone?: boolean }) {
  const page = (
    <PageEmptyState
      icon={<FileQuestion className='h-12 w-12 text-gray-500' strokeWidth={1} />}
      title='Page Not Found'
      description='This page does not exist or you do not have permission to access it.'
      action={
        <Button
          asChild
          size='lg'
          className='w-[280px] py-6 bg-[#290BD9] hover:bg-[#2309C5] text-white shadow-lg flex items-center justify-center'
        >
          <Link to='/campaigns'>GO TO CAMPAIGNS</Link>
        </Button>
      }
    />
  );

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta name='description' content='The requested page could not be found' />
      </Helmet>
      {standalone ? (
        <main className='flex min-h-screen w-full items-center justify-center p-6'>
          <div className='w-full max-w-3xl'>{page}</div>
        </main>
      ) : (
        page
      )}
    </>
  );
}
